import React from 'react'
import { useNavigate } from "react-router";


const TrialEnd = () => {
    const navigate = useNavigate();

  return (
    <>
   <div className="flex items-center justify-center h-screen bg-[#49BCD2] flex-col">
        <h1 className="font-bold text-white mb-2 text-[4em]">Your trial has ended.</h1>
        <h1 onClick={()=>{navigate("/Setting/billing")}} className="text-xl text-white mt-5 border-b-2 border-solid cursor-pointer font-[700]" >See Pricing Plans.</h1>
    </div>
    </>
  )
}

export default TrialEnd